import * as React from 'react';
import { ReviewSnippet } from '@grandvisionhq/reviews';
import '../../context/actions.js';
import '../../context/reducer.js';
import { useProductData } from '../../context/product-context-hooks.js';
import '../../context/ProductContext.js';
import '../../context/CmsContext.js';
import { getReviewsConfigKeys } from './utils/get-reviews-config-keys.js';

const StarRatingReview = ({ className  })=>{
    const { product , activeVariant: { sku  } ,  } = useProductData();
    const { productId , variantId  } = getReviewsConfigKeys(product, sku);
    return /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: className,
        productId: productId,
        variantId: variantId
    });
};

export { StarRatingReview };
//# sourceMappingURL=StarRatingReview.js.map
